import React from 'react';
import clsx from 'clsx';

export interface ChoiceOption {
  id: string;
  title: string;
  subtitle?: string;
}

export interface MultipleChoiceProps {
  options: ChoiceOption[];
  onSelect: (option: ChoiceOption) => void;
  className?: string;
  layout?: 'horizontal' | 'vertical';
  showGlow?: boolean;
}

const MultipleChoice: React.FC<MultipleChoiceProps> = ({
  options,
  onSelect,
  className,
  layout = 'horizontal',
  showGlow = true,
}) => {
  const cardShadow = showGlow
    ? 'shadow-[0_4px_16px_0_rgba(36,137,249,0.18)] hover:shadow-[0_6px_24px_0_rgba(36,137,249,0.28)]'
    : '';

  const layoutClasses =
    layout === 'vertical' ? 'flex-col gap-8' : 'flex-col md:flex-row gap-8 md:gap-12';

  return (
    <div
      className={clsx(
        'flex w-full max-w-4xl justify-center relative z-10',
        layoutClasses,
        className,
      )}
    >
      {options.map((option) => (
        <button
          key={option.id}
          onClick={() => onSelect(option)}
          className={clsx(
            'flex-1 min-w-[260px] max-w-[340px] bg-gradient-to-br from-[#5a5973] via-[#3a3b5a] to-[#23253b] border border-blue-400/30',
            cardShadow,
            'hover:scale-105 hover:brightness-110 transition-all duration-100 rounded-3xl px-6 py-10 flex flex-col items-center justify-center text-center focus:outline-none focus:ring-4 focus:ring-blue-400/40',
          )}
        >
          <span className="text-lg font-semibold font-heading text-white">{option.title}</span>
          {option.subtitle && (
            <span className="block text-sm text-blue-200 mt-2">{option.subtitle}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default MultipleChoice;
